import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import Home from './routes/home/home.component';
import Navigation from './routes/navigation/navigation.component';
import SearchResults from './routes/search-results/search-results.component';
import TripEnsurance from './routes/trip-ensurance/trip-ensurance.component';
import Authentication from './routes/authentication/authentication.component';
import Registration from './routes/registration/registration.component';
import MyOrders from './routes/my-orders/my-orders.component';
import Checkout from './routes/checkout/checkout.component';
import OrderFeedback from './routes/order-feedback/order-feedback.component';
import ForgotPassword from './routes/forgot-password/forgot-password.component';
import ChangePassword from './routes/change-password/change-password.component';
import MultTrip from './routes/mult-trip/mult-trip.component';
import SobreNos from './routes/sobre-nos/sobre-nos.component';
import Duvidas from './routes/duvidas/duvidas.component';
import InsurerPage from './routes/seguradoras/insurer-page.component';
import LegalPage from './routes/legal/legal-page.component';
import Blog from './routes/blog/blog.component';
import BlogPost from './routes/blog/blog-post.component';
import Compare from './routes/compare/compare.component';
import { TERMS_DOC } from './config/legal/terms.data';
import { PRIVACY_DOC } from './config/legal/privacy.data';
import { getPageMeta } from './config/page-meta.data';

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    // Título e descrição de cada página (aparecem na aba e no Google).
    const meta = getPageMeta(pathname);
    if (meta) {
      document.title = meta.title;
      document
        .querySelector('meta[name="description"]')
        ?.setAttribute('content', meta.description);
    }
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<Navigation />}>
        <Route index element={<Home />} />
        <Route path="mult-trip" element={<MultTrip />} />
        <Route path="sobre-nos" element={<SobreNos />} />
        <Route path="duvidas" element={<Duvidas />} />
        <Route path="seguradoras/:slug" element={<InsurerPage />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/:slug" element={<BlogPost />} />
        <Route path="termos-de-uso" element={<LegalPage doc={TERMS_DOC} />} />
        <Route
          path="politica-de-privacidade"
          element={<LegalPage doc={PRIVACY_DOC} />}
        />
        <Route path="search-results" element={<SearchResults />} />
        <Route path="comparar" element={<Compare />} />
        <Route path="trip-ensurance" element={<TripEnsurance />} />
        <Route path="authentication" element={<Authentication />} />
        <Route path="registration" element={<Registration />} />
        <Route path="my-orders" element={<MyOrders />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="order-feedback" element={<OrderFeedback />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="change-password" element={<ChangePassword />} />
      </Route>
    </Routes>
  );
}

export default App;
